"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var events_1 = require("@flowio/events");
var browser_helpers_1 = require("@flowio/browser-helpers");
var find_1 = __importDefault(require("lodash/find"));
var get_1 = __importDefault(require("lodash/get"));
var types_1 = require("../types");
var FacebookPixel = /** @class */ (function () {
    function FacebookPixel(options) {
        var defaultOpts = {
            useBaseCurrency: true,
        };
        var opts = __assign(__assign({}, defaultOpts), options);
        this.useBaseCurrency = opts.useBaseCurrency;
        this.customAttributes = opts.customAttributes;
        var events = new events_1.ChannelEventEmitter();
        events.trigger('pixelFbReady');
    }
    FacebookPixel.test = function (global) {
        if (global === void 0) { global = window; }
        return (typeof global.fbq === 'function');
    };
    FacebookPixel.configureTrackers = function (trackers) {
        trackers.forEach(function (tracker) {
            fbq('init', tracker.tracker_id);
        });
    };
    /**
     * Loads and configure Facebook pixel if not already loaded.
     */
    FacebookPixel.install = function (configuration) {
        var trackers = configuration.trackers;
        // Bail to avoid polluting global scope
        if (!trackers.length) {
            return;
        }
        if (FacebookPixel.test()) {
            FacebookPixel.configureTrackers(trackers);
            return;
        }
        var fbq = window.fbq = function () {
            fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments);
        };
        if (!window._fbq) {
            window._fbq = fbq;
        }
        fbq.push = fbq;
        fbq.loaded = true;
        fbq.version = '2.0';
        fbq.queue = [];
        FacebookPixel.configureTrackers(trackers);
        browser_helpers_1.loadScript('https://connect.facebook.net/en_US/fbevents.js', {
            async: true,
        });
    };
    // FIXME: Remove use of `any` and match overloaded `facebook.Pixel.Event` method
    FacebookPixel.prototype.fireEvent = function (eventType, eventName, parameters) {
        var fbq = window.fbq;
        if (typeof fbq === 'function') {
            window.fbq(eventType, eventName, parameters);
        }
    };
    FacebookPixel.prototype.buildIdArrayFromOrder = function (order) {
        return order.items.map(function (item) { return item.number; });
    };
    FacebookPixel.prototype.fireAddToCart = function (item) {
        var itemCurrency = item.currency;
        var itemPrice = item.price;
        if (this.useBaseCurrency && item.base_price != null && item.base_currency != null) {
            itemCurrency = item.base_currency;
            itemPrice = item.base_price;
        }
        var data = {
            content_ids: [item.id],
            content_name: item.name,
            content_type: 'product',
            contents: [{
                    id: item.id,
                    quantity: item.quantity,
                    item_price: itemPrice,
                }],
            currency: itemCurrency,
            value: item.quantity * itemPrice,
        };
        this.fireEvent('track', 'AddToCart', data);
    };
    FacebookPixel.prototype.fireInitiateCheckoutStep = function (order) {
        var idArray = this.buildIdArrayFromOrder(order);
        var data = {
            content_type: 'product',
            content_ids: idArray,
            value: this.useBaseCurrency ? order.total.base.amount : order.total.amount,
            currency: this.useBaseCurrency ? order.total.base.currency : order.total.currency,
            num_items: order.items.length,
        };
        this.fireEvent('track', 'InitiateCheckout', data);
    };
    FacebookPixel.prototype.fireAddPaymentCheckoutStep = function (order) {
        var idArray = this.buildIdArrayFromOrder(order);
        var data = {
            value: this.useBaseCurrency ? order.total.base.amount : order.total.amount,
            currency: this.useBaseCurrency ? order.total.base.currency : order.total.currency,
            content_ids: idArray,
            content_type: 'product',
        };
        this.fireEvent('track', 'AddPaymentInfo', data);
    };
    FacebookPixel.prototype.firePurchase = function (order) {
        var _this = this;
        var contents = order.items.map(function (item) {
            var id = item.number;
            var quantity = item.quantity;
            var prices = get_1.default(item, 'local.prices', []);
            var itemPrice = find_1.default(prices, function (price) { return price.key === 'localized_item_price'; });
            var itemPriceAmount = _this.useBaseCurrency ? itemPrice.base.amount : itemPrice.amount;
            return {
                id: id,
                quantity: quantity,
                item_price: itemPriceAmount,
            };
        });
        var contentIds = contents.map(function (content) {
            return content.id;
        });
        var data = {
            content: contents,
            value: this.useBaseCurrency ? order.total.base.amount : order.total.amount,
            currency: this.useBaseCurrency ? order.total.base.currency : order.total.currency,
            content_type: 'product',
            num_items: order.items.length,
            content_ids: contentIds,
            order_id: order.number,
        };
        this.fireEvent('track', 'Purchase', data);
    };
    FacebookPixel.prototype.fireContentView = function (value) {
        // FIXME: I don't think PageView event accepts a third parameter.
        // https://developers.facebook.com/docs/facebook-pixel/reference/
        this.fireEvent('track', 'PageView', value);
    };
    FacebookPixel.prototype.event = function (event) {
        switch (event.type) {
            case types_1.PixelEventType.AddToCart:
                this.fireAddToCart(event.data.item);
                break;
            case types_1.PixelEventType.CheckoutInit:
                this.fireInitiateCheckoutStep(event.data.order);
                break;
            case types_1.PixelEventType.CheckoutPaymentSubmitted:
                this.fireAddPaymentCheckoutStep(event.data.order);
                break;
            case types_1.PixelEventType.Purchase:
            case types_1.PixelEventType.Transaction:
                this.firePurchase(event.data.order);
                break;
            case types_1.PixelEventType.PageView:
                this.fireContentView(event.data.value);
                break;
            default:
                break;
        }
    };
    return FacebookPixel;
}());
exports.default = FacebookPixel;



//////////////////
// WEBPACK FOOTER
// ./~/@flowio/pixel/dist/fb/facebookPixel.js
// module id = 607
// module chunks = 0 1